<template>
  <div class="main-area">
    <h2 class="title">n11 kataloğundan hangi ürünü eklemek istersiniz?</h2>
    <div class="search-area">
      <SearchField
        @searchValue="emit('searchText', $event)"
        placeholderText="Ürün Adı, n11 Ürün Linki, Katalog ID, Barkod/GTIN..."
      />
      <AppButton primary lg @click="emit('filterSubmit')" title="Ürün Ara" />
    </div>
    <div class="info-box">
      <span class="info-icon"></span>
      <p>
        Barkod/GTIN, ürünün üzerinde yer alan kod numarasıdır ve her ürün
        seçeneği (varyant) için tanımlanır.
      </p>
    </div>
  </div>
</template>

<script setup>
import { SearchField, AppButton } from "@n11/so-ui-components";

const emit = defineEmits(["searchText", "filterSubmit"]);
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.main-area {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  background-color: $colorN00;
  padding: 24px 24px;
  max-width: 1320px;
  border-radius: 8px;

  .search-area {
    display: flex;
    margin-right: 309px;
  }

  .title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
  }

  > div {
    gap: 16px;

    button {
      max-width: 134px;
    }
  }

  > div {
    input {
      padding-left: 44px;
    }
  }

  .info-box {
    display: flex;
    gap: 8px;
    align-items: center;

    .info-icon {
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44771 11 8C11 8.55229 11.4477 9 12 9C12.5523 9 13 8.55229 13 8ZM12.9933 16.1166C12.9355 16.614 12.5128 17 12 17C11.4477 17 11 16.5523 11 16V11L11.0067 10.8834C11.0645 10.386 11.4872 10 12 10C12.5523 10 13 10.4477 13 11V16L12.9933 16.1166Z' fill='%234FA4E5'/%3E%3C/svg%3E%0A");
      width: 24px;
      height: 24px;
      display: block;
    }

    p {
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: -0.05px;
      color: $colorN70;
    }
  }
}
</style>
